import script from "./UnorderedListRecurring.vue?vue&type=script&setup=true&lang=js"
export * from "./UnorderedListRecurring.vue?vue&type=script&setup=true&lang=js"

import "./UnorderedListRecurring.vue?vue&type=style&index=0&id=0839a946&flex-start=true&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0839a946"]])

export default __exports__